interface StatCardProps {
  label: string;
  value: string | number;
  delta?: string;
  deltaType?: "positive" | "negative" | "warning" | "neutral";
}

export function StatCard({ label, value, delta, deltaType = "positive" }: StatCardProps) {
  const deltaColors = {
    positive: "text-emerald-600",
    negative: "text-red-500",
    warning: "text-amber-500",
    neutral: "text-ds-text-muted",
  };

  return (
    <div className="bg-white border border-ds-border rounded-card p-4">
      <p className="text-xs text-ds-text-muted font-medium uppercase tracking-wide mb-1.5">{label}</p>
      <p className="text-2xl font-semibold text-ds-text">{value}</p>
      {delta && (
        <p className={`text-xs mt-1 ${deltaColors[deltaType]}`}>{delta}</p>
      )}
    </div>
  );
}
